<template>
    <div class="footer-area-wrapper" :class="FooterStyle">
        <div class="footer-area section-space--ptb_90">
            <div class="container">
                <div class="row footer-widget-wrapper">
                    <div class="col-lg-4 col-md-6 footer-widget" style="display:none">
                        <div class="footer-widget__logo mb-30">
                            <router-link to="/">
                                <img src="../assets/img/logo/logo-dark.png" width="94" height="25" class="img-fluid logo-dark" alt="logo">
                                <img src="../assets/img/logo/logo-light.png" width="94" height="25" class="img-fluid logo-light" alt="logo">
                            </router-link>
                        </div>
                        <ul class="footer-widget__list">
                            <li>{{lan.key34[cur_lan]}}</li>
                            <li>
                                <a href="mailto:creissupport@cbre.co.jp" class="hover-style-link">creissupport@cbre.co.jp</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-2 col-md-6 footer-widget">
                        <h6 class="footer-widget__title mb-20"><a href="https://www.cbre.co.jp/ja-jp/about" target="_blank">{{lan.key35[cur_lan]}}</a></h6>
                        <ul class="footer-widget__list">
                            <li>
                                <a href="https://www.cbre.co.jp/ja-jp/about/japan-privacy-policy" target="_blank">{{lan.key36[cur_lan]}}</a>
                            </li>
                            <!-- <li>
                                <a href="https://www.cbre.co.jp/ja-jp/about/japan-term-of-use" target="_blank">{{lan.key37[cur_lan]}}</a>
                            </li> -->

                        </ul>
                    </div>
                    <div class="col-lg-3 col-md-6 footer-widget">
                        <h6 class="footer-widget__title mb-20">{{lan.key38[cur_lan]}}</h6>
                        <ul class="footer-widget__list">
                           
                            <li>
                                <a href="mailto:creissupport@cbre.co.jp" target="_blank" class="hover-style-link">{{lan.key34[cur_lan]}}</a>
                            </li>
                            <li>
                                <a
                    :href="cur_lan=='jp' ?'https://cdn.creis.jp/contract/TermsofUseJP.pdf':'https://creisjapan.s3.ap-northeast-1.amazonaws.com/contract/TermsofUseEN.pdf'"
                    target="_blank"
                    >{{lan.key40[cur_lan]}}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-3 col-md-6 offset-lg-1 footer-widget">
                        <div class="twitter-feed-slider">
                            <div class="swiper-container twitter-feed-slider__container">
                                <div class="swiper-wrapper twitter-feed-slider__wrapper">
                                    <div class="swiper-slide twitter-feed-slider__single">
                                        <!-- <div class="tweet">
                                            <div class="tweet__text">
                                                We deliver market knowledge and global insights.
                                            </div>
                                            <div class="tweet__info">
                                                <h6 class="tweet__heading">CBRE Research</h6>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright-area border-top section-space--ptb_30">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 text-center text-md-left">
                        <span class="copyright-text">
                            Copyright &copy; 2022 <b>CBRE</b>. All right reserved.
                        </span>
                    </div>
                    <div class="col-md-6 text-center text-md-right">
                        <!-- <ul class="list ht-social-networks solid-rounded-icon">
                            <li class="item">
                                <a href="https://www.facebook.com/cbre/" target="_blank" class="social-link"> <i class="fab fa-facebook social-link-icon"></i></a>
                            </li>
                            <li class="item">
                                <a href="https://twitter.com/cbrejapan" target="_blank" class="social-link"> <i class="fab fa-twitter social-link-icon"></i></a>
                            </li>
                            <li class="item">
                                <a href="https://www.linkedin.com/company/cbre/?originalSubdomain=jp" target="_blank" class="social-link"> <i class="fab fa-linkedin social-link-icon"></i></a>
                            </li>
                        </ul> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FooterMain',
        props: ["FooterStyle"],
        data (){
            return {
               
                cur_lan:localStorage.getItem('cur_lan') || 'jp',
                lan:JSON.parse(localStorage.getItem('creis_web_language_data')).data,
            }
        },
    }
</script>
